/**
 * Schema of AuditoriaObservacao
 * @author Simpli CLI generator
 */
import {datetime, InputType, Schema} from 'simpli-web-sdk'
import AuditoriaObservacao from '@/model/resource/AuditoriaObservacao'

export default (model: AuditoriaObservacao): Schema => ({
  carga: {
    content: model.carga && model.carga.$id,
    input: InputType.SELECT,
  },

  responsavel: {
    content: model.responsavel && model.responsavel.$id,
    input: InputType.SELECT,
  },

  idObservacaoPk: {
    content: model.idObservacaoPk,
    editable: false,
  },

  texto: {
    content: model.texto,
    input: InputType.TEXT,
    meta: {
      maxlength: '255',
    },
  },

  replicarCTE: {
    content: [],
    input: InputType.CHECKBOX,
  },

  dataEnvio: {
    content: datetime(model.dataEnvio),
    input: InputType.DATETIME,
    meta: {
      required: true,
    },
  },
})
